module.exports = __webpack_public_path__ + "static/img/服务流程.3cd54ecb.png";